import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { useWizardProgress } from '../../features/wizard/wizardQueries';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H5 } from 'foundations-components/transitional/components/H5';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WizardTitle = ({
  isMobile,
  catGroup
}) => {
  const {
    currentStep
  } = useWizardProgress();
  const getTitleText = () => {
    return currentStep === 'category' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.wizard.modal.stepcategory.title",
      options: {
        categoryGroup: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.filtersGroups.${catGroup}`
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.step${currentStep}.title`
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isMobile ? /*#__PURE__*/_jsx(H5, {
      marginBlockEnd: "400",
      marginBlockStart: "200",
      children: getTitleText()
    }) : /*#__PURE__*/_jsx(H1, {
      marginBlockEnd: "400",
      children: getTitleText()
    })
  });
};
export const WizardSubtitle = ({
  isMobile
}) => {
  const {
    currentStep
  } = useWizardProgress();
  const getSubTitleText = () => {
    return currentStep === 'initial' && /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.wizard.modal.stepinitial.subtitle`
    });
  };
  const content = getSubTitleText();
  if (!content) return null;
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "800",
    maxInlineSize: "470px",
    textAlign: "start",
    children: /*#__PURE__*/_jsx("p", {
      children: isMobile ? content : /*#__PURE__*/_jsx(Big, {
        children: content
      })
    })
  });
};
export default WizardTitle;